import React from 'react';
import styles from './BriefSection.module.scss';

interface BriefSectionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  testID?: string;
}

function BriefSection({title, subtitle, children, testID}: BriefSectionProps) {
  return (
    <section className={styles.section} data-testid={testID}>
      <h2 className={styles.title}>{title}</h2>
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      <div className={styles.body}>{children}</div>
    </section>
  );
}

export default BriefSection;
